
import { filtersDTO, NotImportResponseDTO } from "./dto";
import { NotImportImpl } from "./serviceImpl";

export interface NotImportService {
    GetAllImport(filters: filtersDTO): Promise<NotImportResponseDTO>
}

export function NewNotImportService(): NotImportService {
    return new NotImportImpl()
}